<template>
    <div style="height:100%;">
        <a-row
            type="flex"
            align="middle"
            justify="center"
        >
            <a-col
                :xs="24"
                :sm="8"
                :md="6"
                :lg="6"
                :xl="6"
                justify="center"
                align="middle"
            >
                <div style="width:100%;margin-top:-100px;margin-bottom:10px;text-align:center;font-size:24px;">管理中心</div>
                <div class="alert_box">
                    <a-alert v-if="show_alert" type="error" :message="message" info style="line-height: 24px;" :closable="false" />
                </div>
                <a-input v-model="user" placeholder="请输入用户名">
                    <a-icon slot="prefix" type="user" />
                </a-input>
                <a-input style="margin-top:10px;" placeholder="请输入密码" type="password" v-model="password" show-password>
                    <a-icon slot="prefix" type="lock" />
                </a-input>
                <a-button style="margin-top:10px;width:100%;" type="primary" @click="onSubmit" :disabled="disabled">登 录</a-button>
            </a-col>
        </a-row>
    </div>
</template>

<script>
import axios from 'axios'
import Cookies from 'js-cookie'
export default {
    name: "Login",
    data() {
        return {
            user: '',
            password:'',
            message:'',
            show_alert:false,
            disabled:true,
            json_data:{
                action:'Login',
            },
        }
    },
    watch:{
        user:function () {
            if(this.user.length < 6){
                this.message = '用户名长度不能小于 6 位';
                this.show_alert = true;
                this.disabled = true;
            }else if(this.user.length > 16){
                this.message = '用户名长度不能大于 16 位';
                this.show_alert = true;
                this.disabled = true;
            }else if(this.password.length < 6){
                this.message = '密码长度不能小于 6 位';
                this.show_alert = true;
                this.disabled = true;
            }else if(this.password.length > 16){
                this.message = '密码长度不能大于 16 位';
                this.show_alert = true;
                this.disabled = true;
            }else{
                this.message = '';
                this.show_alert = false;
                this.disabled = false;
            }
        },
        password:function () {
            if(this.password.length < 6){
                this.message = '密码长度不能小于 6 位';
                this.show_alert = true;
                this.disabled = true;
            }else if(this.password.length > 16){
                this.message = '密码长度不能大于 16 位';
                this.show_alert = true;
                this.disabled = true;
            }else if(this.user.length < 6){
                this.message = '用户名长度不能小于 6 位';
                this.show_alert = true;
                this.disabled = true;
            }else if(this.user.length > 16){
                this.message = '用户名长度不能大于 16 位';
                this.show_alert = true;
                this.disabled = true;
            }else{
                this.message = '';
                this.show_alert = false;
                this.disabled = false;
            }
        }
    },
    methods:{
        onSubmit() {
            this.json_data.username = encodeURI(this.user);
            this.json_data.password = encodeURI(this.password);
            var url = 'api/index.php';
            let self = this;
            axios.post(url,this.json_data)
                .then((response)=> {
                    //console.log(response.data.status);
                    if(response.data.status==0){
                        this.message = response.data.message;
                        this.show_alert = true;
                    }else if(response.data.status==1){
                        //登录成功
                        Cookies.set('Token', response.data.token, {expires: 7});//cookie保存7天
                        this.message = '';
                        this.show_alert = false;
                        self.$router.push({path:'/'})
                    }
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });
        }
    }
}
</script>

<style scoped>
    .ant-row-flex{height:100%;background:#f0f2f5;padding-left:10px;padding-right:10px;text-align:center;}
    .alert_box{margin-bottom:10px;text-align:left;}
</style>